/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import { COOKIE, getCookie, getInternalCookie } from 'apmui/common/Cookie';
import { getLandingUri } from 'apmui/common/modelAPI';
import RichText from 'apmui/components/markup/RichTextView';
import ILogoutModel, { MESSAGE, URI } from './Model';

/* View for Message Box */
export default class LogoutPageView extends React.Component<ILogoutModel> {
    render() {
        const landingUri = getLandingUri(this.props);
        const newSessionMessage = this.props.general.policyTimeout.newSessionMessage;
        const messages = this.props.logout.messages.map((msg) => {
            // TODO Separate custom tag to different component LogoutMessageBlock instead
            // TODO This could be improved to use noImplicitReturns check. Check in case of strict compiler options.
            let contents;
            let newSessUri = landingUri;
            if (!newSessUri) {
                newSessUri = msg.uri ? msg.uri : '/';
            }
            switch (msg.type) {
                case MESSAGE.MAIN:
                    contents = <h3>{msg.text}</h3>;
                    break;
                case MESSAGE.TEXT:
                    contents = <p>{msg.text}</p>;
                    break;
                case MESSAGE.RICHTEXT:
                    contents = <RichText text={msg.text || ''} />;
                    break;
                case MESSAGE.NEWSESSION:
                    contents = (
                        <p>
                            <a className="apmui-button apmui-button-submit" href={newSessUri}>
                                {newSessionMessage}
                            </a>
                        </p>
                    );
                    break;
                case MESSAGE.HANGUP:
                    contents = (
                        <p>
                            <a href={URI.HANGUP}>{msg.text}</a>
                        </p>
                    );
                    break;
                case MESSAGE.REFRESH:
                    contents = (
                        <p>
                            <a href={URI.REFRESH}>{msg.text}</a>
                        </p>
                    );
                    break;
                case MESSAGE.BACK:
                    contents = (
                        <p>
                            <a href={URI.BACK}>{msg.text}</a>
                        </p>
                    );
                    break;
                case MESSAGE.SESSION: {
                    const sid = getInternalCookie(COOKIE.LASTMRH_SESSION);
                    if (sid) {
                        contents = (
                            <p>
                                {msg.text} {sid}
                            </p>
                        );
                    }
                    break;
                }
                case MESSAGE.SWGSESSION: {
                    const swgsid = getInternalCookie(COOKIE.APM_SWG_LASTMRH_SESSSION);
                    if (swgsid) {
                        contents = (
                            <p>
                                {msg.text} {swgsid}
                            </p>
                        );
                    }
                    break;
                }
                case MESSAGE.APPLICATIONNAME: {
                    const name = getCookie(COOKIE.APM_APPLICATION_NAME);
                    if (name) {
                        contents = (
                            <p>
                                {msg.text} {name}
                            </p>
                        );
                    }
                    break;
                }
                case MESSAGE.APPLICATIONFAMILY: {
                    const family = getCookie(COOKIE.APM_APPLICATION_FAMILY);
                    if (family) {
                        contents = (
                            <p>
                                {msg.text} {family}
                            </p>
                        );
                    }
                    break;
                }
                case MESSAGE.URI:
                    if (msg.uri) {
                        contents = (
                            <p>
                                <a href={msg.uri}>{msg.text}</a>
                            </p>
                        );
                    }
                    break;
            }
            return contents;
        });

        return <div className="apmui-content">{messages}</div>;
    }
}
